import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import { userPersistencePlugin } from '@/plugins/userStorePersistencePlugin';
import posthogPlugin from '@/plugins/posthog';
import LAA_logger from './logger';
import { setupNonceRefreshOnFocus } from '@/utils/nonce.js';
import '@/style.css';

const app = createApp(App);
const pinia = createPinia();
pinia.use(userPersistencePlugin);

window.$log = LAA_logger; // Make the logger globally available

// Set up proactive nonce refresh when user returns to tab
setupNonceRefreshOnFocus();

app.use(pinia);
app.use(router);
app.use(posthogPlugin, { router }); // Initialize PostHog with router for automatic pageview tracking

app.mount('#luxxbox-acoustic-analyzer');
